import { render, staticRenderFns } from "./specialGoods.vue?vue&type=template&id=509b0cc4&scoped=true&"
import script from "./specialGoods.vue?vue&type=script&lang=js&"
export * from "./specialGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509b0cc4",
  null
  
)

export default component.exports